export default "__VITE_ASSET__wpeyzyfU__"